import { useEffect, useRef, useState } from "react";
import * as pdfjs from "pdfjs-dist/legacy/build/pdf";

pdfjs.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@3.11.174/legacy/build/pdf.worker.min.js";

export function PdfView({ blob }) {
  const ref = useRef(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    const box = ref.current;
    (async () => {
      try {
        const doc = await pdfjs.getDocument({ data: await blob.arrayBuffer() }).promise;
        const width = box.clientWidth || 600;
        for (let i = 1; i <= doc.numPages && !cancelled; i += 1) {
          const page = await doc.getPage(i);
          const base = page.getViewport({ scale: 1 });
          const ratio = window.devicePixelRatio || 1;
          const vp = page.getViewport({ scale: (width / base.width) * ratio });
          const canvas = document.createElement("canvas");
          canvas.width = vp.width; canvas.height = vp.height;
          canvas.style.width = "100%";
          canvas.className = "rounded-lg shadow-sm bg-white mb-3";
          await page.render({ canvasContext: canvas.getContext("2d"), viewport: vp }).promise;
          if (!cancelled) box.appendChild(canvas);
        }
      } catch { setError("Не удалось открыть PDF"); }
    })();
    return () => { cancelled = true; box.innerHTML = ""; };
  }, [blob]);
  return (
    <div>
      {error && <p className="text-sm text-red-600">{error}</p>}
      <div ref={ref} className="max-h-[70vh] overflow-y-auto select-none" data-testid="viewer-pdf" />
    </div>
  );
}
